export default __webpack_public_path__ + "static/media/Frame 222.b89b080b.svg";